import {useCallback} from 'react'
import {useMappedState} from 'redux-react-hook'

export default function useOpenFutureStatus () {
  const mapState = useCallback(
    state => ({
      openFutureStatus: state.openAccountInfo.isOpenAccount
    }),
    []
  )
  const {openFutureStatus = false} = useMappedState(mapState)
  return openFutureStatus
}
